var _assertThisInitialized = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _classCallCheck = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _get = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");
var _inherits = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
/*!
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */
(function () {
  var t = {
      704: function _(t, e, o) {
        t.exports = o(79)("./src/core.js");
      },
      492: function _(t, e, o) {
        t.exports = o(79)("./src/engine.js");
      },
      273: function _(t, e, o) {
        t.exports = o(79)("./src/ui.js");
      },
      209: function _(t, e, o) {
        t.exports = o(79)("./src/utils.js");
      },
      79: function _(t) {
        "use strict";

        t.exports = CKEditor5.dll;
      }
    },
    e = {};
  function o(i) {
    var r = e[i];
    if (void 0 !== r) return r.exports;
    var n = e[i] = {
      exports: {}
    };
    return t[i](n, n.exports, o), n.exports;
  }
  o.d = function (t, e) {
    for (var i in e) o.o(e, i) && !o.o(t, i) && Object.defineProperty(t, i, {
      enumerable: !0,
      get: e[i]
    });
  }, o.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, o.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  };
  var i = {};
  (function () {
    "use strict";

    o.r(i), o.d(i, {
      InlineEditor: function InlineEditor() {
        return S;
      }
    });
    var t = o(704),
      e = o(209);
    var r = function r(t) {
      return null != t && "object" == typeof t;
    };
    var n = "object" == typeof global && global && global.Object === Object && global;
    var s = "object" == typeof self && self && self.Object === Object && self;
    var l = (n || s || Function("return this")()).Symbol;
    var a = Object.prototype,
      c = a.hasOwnProperty,
      d = a.toString,
      h = l ? l.toStringTag : void 0;
    var u = function u(t) {
      var e = c.call(t, h),
        o = t[h];
      try {
        t[h] = void 0;
        var i = !0;
      } catch (t) {}
      var r = d.call(t);
      return i && (e ? t[h] = o : delete t[h]), r;
    };
    var p = Object.prototype.toString;
    var b = function b(t) {
      return p.call(t);
    };
    var f = l ? l.toStringTag : void 0;
    var g = function g(t) {
      return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : f && f in Object(t) ? u(t) : b(t);
    };
    var w = function (t, e) {
      return function (o) {
        return t(e(o));
      };
    }(Object.getPrototypeOf, Object);
    var v = Function.prototype,
      m = Object.prototype,
      y = v.toString,
      O = m.hasOwnProperty,
      T = y.call(Object);
    var j = function j(t) {
      if (!r(t) || "[object Object]" != g(t)) return !1;
      var e = w(t);
      if (null === e) return !0;
      var o = O.call(e, "constructor") && e.constructor;
      return "function" == typeof o && o instanceof o && y.call(o) == T;
    };
    var E = function E(t) {
      return r(t) && 1 === t.nodeType && !j(t);
    };
    var P = o(273),
      x = o(492);
    var _ = /*#__PURE__*/function (_t$EditorUI) {
      _inherits(_, _t$EditorUI);
      function _(t, e) {
        var _this;
        _classCallCheck(this, _);
        _this = _possibleConstructorReturn(this, _getPrototypeOf(_).call(this, t)), _this.view = e, _this._toolbarConfig = (0, P.normalizeToolbarConfig)(t.config.get("toolbar"));
        return _this;
      }
      _createClass(_, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = this.view,
            o = t.editing.view,
            i = e.editable,
            r = o.document.getRoot();
          i.name = r.rootName, e.render();
          var n = i.element;
          this.setEditableElement(i.name, n), this.focusTracker.add(n), i.bind("isFocused").to(this.focusTracker), o.attachDomRoot(n), this._initPlaceholder(), this._initToolbar(), this.fire("ready");
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var t = this.view;
          this.editor.editing.view.detachDomRoot(t.editable.name), t.destroy(), _superPropGet(_, "destroy", this, 3)([]);
        }
      }, {
        key: "_initToolbar",
        value: function _initToolbar() {
          var t = this.editor,
            e = this.view,
            o = e.editable.element,
            i = t.editing.view,
            r = e.toolbar;
          e.panel.bind("isVisible").to(this.focusTracker, "isFocused"), e.bind("viewportTopOffset").to(this, "viewportOffset", function (_ref) {
            var t = _ref.top;
            return t;
          }), e.listenTo(t.ui, "update", function () {
            e.panel.isVisible && e.panel.pin({
              target: o,
              positions: e.panelPositions
            });
          }), r.fillFromConfig(this._toolbarConfig, this.componentFactory), (0, P.enableToolbarKeyboardFocus)({
            origin: i,
            originFocusTracker: this.focusTracker,
            originKeystrokeHandler: t.keystrokes,
            toolbar: r
          });
        }
      }, {
        key: "_initPlaceholder",
        value: function _initPlaceholder() {
          var t = this.editor,
            e = t.editing.view,
            o = e.document.getRoot(),
            i = t.sourceElement,
            r = t.config.get("placeholder") || i && "textarea" === i.tagName.toLowerCase() && i.getAttribute("placeholder");
          r && (0, x.enablePlaceholder)({
            view: e,
            element: o,
            text: r,
            isDirectHost: !1,
            keepOnFocus: !0
          });
        }
      }, {
        key: "element",
        get: function get() {
          return this.view.editable.element;
        }
      }]);
      return _;
    }(t.EditorUI);
    var F = (0, e.toUnit)("px");
    var D = /*#__PURE__*/function (_P$EditorUIView) {
      _inherits(D, _P$EditorUIView);
      function D(t, e, o) {
        var _this2;
        var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        _classCallCheck(this, D);
        _this2 = _possibleConstructorReturn(this, _getPrototypeOf(D).call(this, t)), _this2.toolbar = new P.ToolbarView(t, {
          shouldGroupWhenFull: i.shouldToolbarGroupWhenFull,
          isFloating: !0
        }), _this2.set("viewportTopOffset", 0), _this2.panel = new P.BalloonPanelView(t), _this2.panelPositions = _this2._getPanelPositions(), _this2.panel.extendTemplate({
          attributes: {
            class: "ck-toolbar-container"
          }
        }), _this2.editable = new P.InlineEditableUIView(t, e, o), _this2._resizeObserver = null;
        return _this2;
      }
      _createClass(D, [{
        key: "render",
        value: function render() {
          var _this3 = this;
          _superPropGet(D, "render", this, 3)([]), this.body.add(this.panel), this.registerChild(this.editable), this.panel.content.add(this.toolbar);
          if (this.toolbar.options.shouldGroupWhenFull) {
            var _t = this.editable.element;
            this._resizeObserver = new e.ResizeObserver(_t, function () {
              _this3.toolbar.maxWidth = F(new e.Rect(_t).width);
            });
          }
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _superPropGet(D, "destroy", this, 3)([]), this._resizeObserver && this._resizeObserver.destroy();
        }
      }, {
        key: "_getPanelPositionTop",
        value: function _getPanelPositionTop(t, e) {
          var o;
          return o = t.top > e.height + this.viewportTopOffset ? t.top - e.height : t.bottom > e.height + this.viewportTopOffset + 50 ? this.viewportTopOffset : t.bottom, o;
        }
      }, {
        key: "_getPanelPositions",
        value: function _getPanelPositions() {
          var _this4 = this;
          var t = [function (t, e) {
            return {
              top: _this4._getPanelPositionTop(t, e),
              left: t.left,
              name: "toolbar_west",
              config: {
                withArrow: !1
              }
            };
          }, function (t, e) {
            return {
              top: _this4._getPanelPositionTop(t, e),
              left: t.left + t.width - e.width,
              name: "toolbar_east",
              config: {
                withArrow: !1
              }
            };
          }];
          return "ltr" === this.locale.uiLanguageDirection ? t : t.reverse();
        }
      }]);
      return D;
    }(P.EditorUIView);
    var S = /*#__PURE__*/function (_t$Editor) {
      _inherits(S, _t$Editor);
      function S(o) {
        var _this5;
        var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _classCallCheck(this, S);
        if (!E(o) && void 0 !== i.initialData) throw new e.CKEditorError("editor-create-initial-data", null);
        _this5 = _possibleConstructorReturn(this, _getPrototypeOf(S).call(this, i)), void 0 === _this5.config.get("initialData") && _this5.config.set("initialData", function (t) {
          return E(t) ? (0, e.getDataFromElement)(t) : t;
        }(o)), _this5.model.document.createRoot(), E(o) && (_this5.sourceElement = o, (0, t.secureSourceElement)(_assertThisInitialized(_assertThisInitialized(_this5))));
        var r = !_this5.config.get("toolbar.shouldNotGroupWhenFull"),
          n = new D(_this5.locale, _this5.editing.view, _this5.sourceElement, {
            shouldToolbarGroupWhenFull: r
          });
        _this5.ui = new _(_assertThisInitialized(_assertThisInitialized(_this5)), n), (0, t.attachToForm)(_assertThisInitialized(_assertThisInitialized(_this5)));
        return _this5;
      }
      _createClass(S, [{
        key: "destroy",
        value: function destroy() {
          var _this6 = this;
          var t = this.getData();
          return this.ui.destroy(), _superPropGet(S, "destroy", this, 3)([]).then(function () {
            _this6.sourceElement && (0, e.setDataInElement)(_this6.sourceElement, t);
          });
        }
      }], [{
        key: "create",
        value: function create(t) {
          var _this7 = this;
          var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return new Promise(function (i) {
            if (E(t) && "TEXTAREA" === t.tagName) throw new e.CKEditorError("editor-wrong-element", null);
            var r = new _this7(t, o);
            i(r.initPlugins().then(function () {
              return r.ui.init();
            }).then(function () {
              return r.data.init(r.config.get("initialData"));
            }).then(function () {
              return r.fire("ready");
            }).then(function () {
              return r;
            }));
          });
        }
      }]);
      return S;
    }(t.Editor);
    (0, e.mix)(S, t.DataApiMixin), (0, e.mix)(S, t.ElementApiMixin);
  })(), (window.CKEditor5 = window.CKEditor5 || {}).editorInline = i;
})();